export default "__VITE_ASSET__0a2b66d1__"